/* Action Types */
export const LOAD_SIMILAR_ITEMS_V3_FAIL = 'la/domain/similarItemsV3/LOAD_FAIL';
export const LOAD_SIMILAR_ITEMS_V3_REQUEST = 'la/domain/similarItemsV3/LOAD_REQUEST';
export const LOAD_SIMILAR_ITEMS_V3_SUCCESS = 'la/domain/similarItemsV3/LOAD_SUCCESS';
